export default __webpack_public_path__ + "images/7e4fc076ffb183f10498e552c9c9b8aa.png";